import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class CoderEditorElement
{
  static readonly type = new ElementType( "coder-editor" );

  static applyOnDocument()
  {
    CoderEditorElement.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    var img = ElementType.image.create();

    img.src = "../../../_graphics/testing/coder-editor.svg";
    img.style.width = "calc( var( --sw ) * 100 )";

    e.appendChild( img );
  }
}